export default __webpack_public_path__ + "static/peel-hero-0a9a418e14d6bb89829f8fb885898106.jpg";